import { useRef, useImperativeHandle, useEffect } from 'react';
import TableInstanceApiSingleton from '../manager/TableInstanceApiSingleton';

const useInitTableInstanceApi = (props) => {
    const { elementId, hotTableInstanceRef } = props;

    const tableInstanceApiRef = useRef(null);

    // Expose methods to HotTableManager via imperative handle
    useImperativeHandle(
        tableInstanceApiRef,
        () => ({
            hotTableInstanceRef,
        }),
        [hotTableInstanceRef],
    );

    useEffect(() => {
        TableInstanceApiSingleton.add(elementId, tableInstanceApiRef.current);

        return () => {
            TableInstanceApiSingleton.remove(elementId);
        };
    }, []);
};

export default useInitTableInstanceApi;
